/*
  Navegacao antecipada (regras speculationrules em layout/theme.liquid): quando a pagina chegou por uma busca
  antecipada do HTML, o carrinho pode ter mudado depois dessa busca. Depois do load, pede ao tema para atualizar
  o carrinho (contagem e gaveta) com o evento cart:refresh. Navegacao normal nao faz nada.
*/
(() => {
  const entrada = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
  if (!entrada || entrada.deliveryType !== 'navigational-prefetch') return;

  const atualizar = () => document.dispatchEvent(new CustomEvent('cart:refresh'));

  if (document.readyState === 'complete') {
    atualizar();
  } else {
    window.addEventListener('load', atualizar, { once: true });
  }
})();
